import {
  AppleLogoIcon,
  ArchiveIcon,
  ArrowBendDoubleUpRightIcon,
  ArrowClockwiseIcon,
  ArrowCounterClockwiseIcon,
  ArrowElbowDownRightIcon,
  ArrowDownIcon,
  ArrowFatLineDownIcon,
  ArrowFatLineUpIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowsClockwiseIcon,
  ArrowsDownUpIcon,
  ArrowsInIcon,
  ArrowsInLineHorizontalIcon,
  ArrowsInSimpleIcon,
  ArrowsLeftRightIcon,
  ArrowsOutIcon,
  ArrowsOutLineHorizontalIcon,
  ArrowsOutSimpleIcon,
  ArrowSquareOutIcon,
  ArrowSquareRightIcon,
  ArrowsSplitIcon,
  ArrowUpIcon,
  ArrowUUpRightIcon,
  ArticleIcon,
  BankIcon,
  BellIcon,
  BriefcaseIcon,
  BugDroidIcon,
  BuildingIcon,
  BuildingsIcon,
  CalendarBlankIcon,
  CalendarCheckIcon,
  CalendarDotsIcon,
  CalendarPlusIcon,
  CardholderIcon,
  CaretCircleDownIcon,
  CaretDownIcon,
  CaretLeftIcon,
  CaretRightIcon,
  CaretUpIcon,
  CertificateIcon,
  ChampagneIcon,
  ChartDonutIcon,
  ChartLineDownIcon,
  ChartLineIcon,
  ChartLineUpIcon,
  ChatDotsIcon,
  ChatsIcon,
  ChatTextIcon,
  CheckCircleIcon,
  CheckIcon,
  CheckSquareIcon,
  CircleIcon,
  CircleNotchIcon,
  CityIcon,
  ClipboardTextIcon,
  ClockClockwiseIcon,
  ClockCounterClockwiseIcon,
  ClockIcon,
  CodeBlockIcon,
  CopyIcon,
  CornersInIcon,
  CornersOutIcon,
  CreditCardIcon,
  CurrencyCircleDollarIcon,
  DetectiveIcon,
  DeviceMobileIcon,
  DotIcon,
  DotOutlineIcon,
  DotsNineIcon,
  DotsSixVerticalIcon,
  DotsThreeIcon,
  DotsThreeVerticalIcon,
  DownloadSimpleIcon,
  EnvelopeIcon,
  EnvelopeSimpleOpenIcon,
  EyeClosedIcon,
  EyeIcon,
  FadersHorizontalIcon,
  FastForwardIcon,
  FileDashedIcon,
  FileDocIcon,
  FileIcon,
  FileJpgIcon,
  FileLockIcon,
  FileMagnifyingGlassIcon,
  FileMinusIcon,
  FilePdfIcon,
  FilePlusIcon,
  FilePngIcon,
  FilesIcon,
  FileTextIcon,
  FileXIcon,
  FileXlsIcon,
  FloppyDiskIcon,
  FlagCheckeredIcon,
  FlaskIcon,
  FolderLockIcon,
  FolderNotchIcon,
  FolderOpenIcon,
  FolderPlusIcon,
  FoldersIcon,
  FolderSimpleUserIcon,
  FunnelIcon,
  GaugeIcon,
  GavelIcon,
  GearIcon,
  GiftIcon,
  GitCommitIcon,
  GitForkIcon,
  GlobeIcon,
  GoogleLogoIcon,
  GraphIcon,
  GridNineIcon,
  HandIcon,
  HandshakeIcon,
  HashIcon,
  HashStraightIcon,
  HourglassIcon,
  HouseIcon,
  HouseLineIcon,
  IdentificationBadgeIcon,
  IdentificationCardIcon,
  InfinityIcon,
  InfoIcon,
  LightbulbIcon,
  LightningAIcon,
  LightningIcon,
  LinkIcon,
  ListBulletsIcon,
  ListChecksIcon,
  ListIcon,
  ListMagnifyingGlassIcon,
  ListNumbersIcon,
  ListPlusIcon,
  ListStarIcon,
  LockKeyIcon,
  LockSimpleIcon,
  LockSimpleOpenIcon,
  MagicWandIcon,
  MagnifyingGlassIcon,
  MagnifyingGlassMinusIcon,
  MagnifyingGlassPlusIcon,
  MapPinIcon,
  MapPinSimpleAreaIcon,
  MegaphoneIcon,
  MicrosoftExcelLogoIcon,
  MicrosoftOutlookLogoIcon,
  MicrosoftPowerpointLogoIcon,
  MicrosoftWordLogoIcon,
  MinusIcon,
  MinusSquareIcon,
  MoneyIcon,
  MonitorIcon,
  MoonIcon,
  NotebookIcon,
  NotePencilIcon,
  PaintBrushBroadIcon,
  PaintBrushIcon,
  PaperclipIcon,
  PaperPlaneRightIcon,
  PaperPlaneTiltIcon,
  ParachuteIcon,
  PeaceIcon,
  PencilSimpleIcon,
  PenIcon,
  PersonIcon,
  PhoneIcon,
  PiggyBankIcon,
  PlugsConnectedIcon,
  PlugsIcon,
  PlusIcon,
  PlusSquareIcon,
  PolygonIcon,
  PottedPlantIcon,
  PrinterIcon,
  ProjectorScreenIcon,
  PuzzlePieceIcon,
  QuestionIcon,
  RadioactiveIcon,
  ReceiptIcon,
  RocketLaunchIcon,
  RowsIcon,
  ScrollIcon,
  SealCheckIcon,
  ShieldCheckIcon,
  ShoppingCartSimpleIcon,
  SidebarSimpleIcon,
  SignatureIcon,
  SignInIcon,
  SignOutIcon,
  SortAscendingIcon,
  SortDescendingIcon,
  SparkleIcon,
  SquareIcon,
  SquareSplitHorizontalIcon,
  SquaresFourIcon,
  StackMinusIcon,
  StarIcon,
  StepsIcon,
  SuitcaseSimpleIcon,
  SunIcon,
  SwapIcon,
  TableIcon,
  TabsIcon,
  TagIcon,
  TextAaIcon,
  TextAlignLeftIcon,
  TextBolderIcon,
  TextboxIcon,
  TextItalicIcon,
  TextSubscriptIcon,
  TextSuperscriptIcon,
  TextUnderlineIcon,
  ThumbsDownIcon,
  ThumbsUpIcon,
  TrashIcon,
  TreeStructureIcon,
  TreeViewIcon,
  TrendUpIcon,
  UniteIcon,
  UploadSimpleIcon,
  UserCheckIcon,
  UserCircleGearIcon,
  UserCircleIcon,
  UserCirclePlusIcon,
  UserFocusIcon,
  UserIcon,
  UserListIcon,
  UserMinusIcon,
  UserPlusIcon,
  UsersIcon,
  UserSquareIcon,
  UsersThreeIcon,
  UserSwitchIcon,
  VideoCameraIcon,
  WalletIcon,
  WarningCircleIcon,
  WarningIcon,
  WebcamIcon,
  XCircleIcon,
  XIcon,
  XSquareIcon,
} from "@phosphor-icons/react";

export const iconMap = {
  "apple-logo": <AppleLogoIcon />,
  archive: <ArchiveIcon />,
  "arrow-bend-double-up-right": <ArrowBendDoubleUpRightIcon />,
  "arrow-clockwise": <ArrowClockwiseIcon />,
  "arrow-counter-clockwise": <ArrowCounterClockwiseIcon />,
  "arrow-elbow-down-right": <ArrowElbowDownRightIcon />,
  "arrow-down": <ArrowDownIcon />,
  "arrows-down-up": <ArrowsDownUpIcon />,
  "arrow-fat-line-down": <ArrowFatLineDownIcon />,
  "arrow-fat-line-up": <ArrowFatLineUpIcon />,
  "arrow-left": <ArrowLeftIcon />,
  "arrow-right": <ArrowRightIcon />,
  "arrow-square-out": <ArrowSquareOutIcon />,
  "arrow-square-right": <ArrowSquareRightIcon />,
  "arrow-u-up-right": <ArrowUUpRightIcon />,
  "arrow-up": <ArrowUpIcon />,
  "arrows-clockwise": <ArrowsClockwiseIcon />,
  "arrows-in": <ArrowsInIcon />,
  "arrows-in-line-horizontal": <ArrowsInLineHorizontalIcon />,
  "arrows-in-simple": <ArrowsInSimpleIcon />,
  "arrows-left-right": <ArrowsLeftRightIcon />,
  "arrows-out": <ArrowsOutIcon />,
  "arrows-out-line-horizontal": <ArrowsOutLineHorizontalIcon />,
  "arrows-out-simple": <ArrowsOutSimpleIcon />,
  article: <ArticleIcon />,
  bank: <BankIcon />,
  bell: <BellIcon />,
  briefcase: <BriefcaseIcon />,
  buildings: <BuildingsIcon />,
  building: <BuildingIcon />,
  "bug-droid": <BugDroidIcon />,
  calendar: <CalendarBlankIcon />,
  "calendar-check": <CalendarCheckIcon />,
  "calendar-dots": <CalendarDotsIcon />,
  "calendar-plus": <CalendarPlusIcon />,
  "card-holder": <CardholderIcon />,
  "caret-circle-down": <CaretCircleDownIcon />,
  "caret-down": <CaretDownIcon />,
  "caret-left": <CaretLeftIcon />,
  "caret-right": <CaretRightIcon />,
  "caret-up": <CaretUpIcon />,
  certificate: <CertificateIcon />,
  champagne: <ChampagneIcon />,
  "chart-donut": <ChartDonutIcon />,
  "chart-line": <ChartLineIcon />,
  "chart-line-up": <ChartLineUpIcon />,
  "chart-line-down": <ChartLineDownIcon />,
  "chat-dots": <ChatDotsIcon />,
  chats: <ChatsIcon />,
  "chat-text": <ChatTextIcon />,
  check: <CheckIcon />,
  "check-circle": <CheckCircleIcon />,
  "check-square": <CheckSquareIcon />,
  circle: <CircleIcon />,
  "circle-notch": <CircleNotchIcon />,
  city: <CityIcon />,
  "clipboard-text": <ClipboardTextIcon />,
  clock: <ClockIcon />,
  "clock-clockwise": <ClockClockwiseIcon />,
  "clock-counter-clockwise": <ClockCounterClockwiseIcon />,
  "code-block": <CodeBlockIcon />,
  copy: <CopyIcon />,
  "corners-out": <CornersOutIcon />,
  "corners-in": <CornersInIcon />,
  "credit-card": <CreditCardIcon />,
  "currency-circle-dollar": <CurrencyCircleDollarIcon />,
  detective: <DetectiveIcon />,
  devicemobile: <DeviceMobileIcon />,
  "arrows-split": <ArrowsSplitIcon />,
  dot: <DotIcon />,
  dotdotdot: <DotsThreeIcon />,
  "dotdotdot-vertical": <DotsThreeVerticalIcon />,
  "dot-outline": <DotOutlineIcon />,
  "dots-six-vertical": <DotsSixVerticalIcon />,
  "dots-nine": <DotsNineIcon />,
  download: <DownloadSimpleIcon />,
  edit: <PencilSimpleIcon />,
  envelope: <EnvelopeIcon />,
  "envelope-simple-open": <EnvelopeSimpleOpenIcon />,
  eye: <EyeIcon />,
  "eye-closed": <EyeClosedIcon />,
  excel: <FileXlsIcon />,
  "faders-horizontal": <FadersHorizontalIcon />,
  "fast-forward": <FastForwardIcon />,
  file: <FileIcon />,
  files: <FilesIcon />,
  "floppy-disk": <FloppyDiskIcon />,
  "file-dashed": <FileDashedIcon />,
  "file-doc": <FileDocIcon />,
  "file-jpg": <FileJpgIcon />,
  "file-lock": <FileLockIcon />,
  "file-magnifying-glass": <FileMagnifyingGlassIcon />,
  "file-minus": <FileMinusIcon />,
  "file-pdf": <FilePdfIcon />,
  "file-png": <FilePngIcon />,
  "file-plus": <FilePlusIcon />,
  "file-text": <FileTextIcon />,
  "file-x": <FileXIcon />,
  "file-xls": <FileXlsIcon />,
  "flag-checkered": <FlagCheckeredIcon />,
  "flag-norway": "\uD83C\uDDF3\uD83C\uDDF4",
  "flag-sweden": "\uD83C\uDDF8\uD83C\uDDEA",
  flask: <FlaskIcon />,
  folder: <FolderNotchIcon />,
  "folder-lock": <FolderLockIcon />,
  "folder-open": <FolderOpenIcon />,
  "folder-plus": <FolderPlusIcon />,
  "folder-user": <FolderSimpleUserIcon />,
  folders: <FoldersIcon />,
  funnel: <FunnelIcon />,
  gavel: <GavelIcon />,
  gear: <GearIcon />,
  gift: <GiftIcon />,
  "git-commit": <GitCommitIcon />,
  "git-fork": <GitForkIcon />,
  globe: <GlobeIcon />,
  "google-logo": <GoogleLogoIcon />,
  graph: <GraphIcon />,
  grid: <GridNineIcon />,
  hand: <HandIcon />,
  handshake: <HandshakeIcon />,
  hash: <HashIcon />,
  "hash-straight": <HashStraightIcon />,
  hourglass: <HourglassIcon />,
  house: <HouseIcon />,
  houseline: <HouseLineIcon />,
  "identification-badge": <IdentificationBadgeIcon />,
  "identification-card": <IdentificationCardIcon />,
  info: <InfoIcon />,
  lightbulb: <LightbulbIcon />,
  lightning: <LightningIcon />,
  "lightning-a": <LightningAIcon />,
  link: <LinkIcon />,
  list: <ListIcon />,
  "list-bullets": <ListBulletsIcon />,
  "list-checks": <ListChecksIcon />,
  "list-magnifying-glass": <ListMagnifyingGlassIcon />,
  "list-numbers": <ListNumbersIcon />,
  "list-star": <ListStarIcon />,
  "list-plus": <ListPlusIcon />,
  lock: <LockSimpleIcon />,
  "lock-simple-open": <LockSimpleOpenIcon />,
  infinity: <InfinityIcon />,
  gauge: <GaugeIcon />,
  "lock-key": <LockKeyIcon />,
  "magic-wand": <MagicWandIcon />,
  "magnifying-glass": <MagnifyingGlassIcon />,
  "magnifying-glass-minus": <MagnifyingGlassMinusIcon />,
  "magnifying-glass-plus": <MagnifyingGlassPlusIcon />,
  "map-pin": <MapPinIcon />,
  "map-pin-area": <MapPinSimpleAreaIcon />,
  megaphone: <MegaphoneIcon />,
  "microsoft-outlook-logo": <MicrosoftOutlookLogoIcon />,
  "microsoft-excel-logo": <MicrosoftExcelLogoIcon />,
  "microsoft-word-logo": <MicrosoftWordLogoIcon />,
  "microsoft-powerpoint-logo": <MicrosoftPowerpointLogoIcon />,
  minus: <MinusIcon />,
  "minus-square": <MinusSquareIcon />,
  money: <MoneyIcon />,
  monitor: <MonitorIcon />,
  moon: <MoonIcon />,
  notebook: <NotebookIcon />,
  "note-pencil": <NotePencilIcon />,
  "paint-brush": <PaintBrushIcon />,
  paperclip: <PaperclipIcon />,
  "paper-plane": <PaperPlaneTiltIcon />,
  "paper-plane-right": <PaperPlaneRightIcon />,
  "paint-brush-broad": <PaintBrushBroadIcon />,
  parachute: <ParachuteIcon />,
  peace: <PeaceIcon />,
  pen: <PenIcon />,
  person: <PersonIcon />,
  phone: <PhoneIcon />,
  "piggy-bank": <PiggyBankIcon />,
  plugs: <PlugsIcon />,
  "plugs-connected": <PlugsConnectedIcon />,
  plus: <PlusIcon />,
  "plus-square": <PlusSquareIcon />,
  polygon: <PolygonIcon />,
  "potted-plant": <PottedPlantIcon />,
  printer: <PrinterIcon />,
  "puzzle-piece": <PuzzlePieceIcon />,
  question: <QuestionIcon />,
  radioActive: <RadioactiveIcon />,
  receipt: <ReceiptIcon />,
  rocket: <RocketLaunchIcon />,
  rows: <RowsIcon />,
  scroll: <ScrollIcon />,
  "seal-check": <SealCheckIcon />,
  "shield-check": <ShieldCheckIcon />,
  "shopping-cart-simple": <ShoppingCartSimpleIcon />,
  "sidebar-simple": <SidebarSimpleIcon />,
  "sign-in": <SignInIcon />,
  "sign-out": <SignOutIcon />,
  signature: <SignatureIcon />,
  "sort-ascending": <SortAscendingIcon />,
  "sort-descending": <SortDescendingIcon />,
  sparkle: <SparkleIcon />,
  square: <SquareIcon />,
  "projector-screen": <ProjectorScreenIcon />,
  "square-split-horizontal": <SquareSplitHorizontalIcon />,
  "squares-four": <SquaresFourIcon />,
  star: <StarIcon />,
  steps: <StepsIcon />,
  suitcaseSimple: <SuitcaseSimpleIcon />,
  "stack-minus": <StackMinusIcon />,
  sun: <SunIcon />,
  swap: <SwapIcon />,
  table: <TableIcon />,
  tabs: <TabsIcon />,
  tag: <TagIcon />,
  "text-aa": <TextAaIcon />,
  "text-bolder": <TextBolderIcon />,
  "text-box": <TextboxIcon />,
  "text-italic": <TextItalicIcon />,
  "text-lines": <TextAlignLeftIcon />,
  "text-subscript": <TextSubscriptIcon />,
  "text-superscript": <TextSuperscriptIcon />,
  "text-underline": <TextUnderlineIcon />,
  "thumbs-up": <ThumbsUpIcon />,
  "thumbs-down": <ThumbsDownIcon />,
  trash: <TrashIcon />,
  "trend-up": <TrendUpIcon />,
  treeStructure: <TreeStructureIcon />,
  treeView: <TreeViewIcon />,
  upload: <UploadSimpleIcon />,
  user: <UserIcon />,
  "user-circle": <UserCircleIcon />,
  "user-check": <UserCheckIcon />,
  "user-circle-gear": <UserCircleGearIcon />,
  "user-circle-plus": <UserCirclePlusIcon />,
  "user-focus": <UserFocusIcon />,
  "user-minus": <UserMinusIcon />,
  "user-plus": <UserPlusIcon />,
  "user-list": <UserListIcon />,
  "user-square": <UserSquareIcon />,
  "user-switch": <UserSwitchIcon />,
  users: <UsersIcon />,
  "users-three": <UsersThreeIcon />,
  unite: <UniteIcon />,
  "video-camera": <VideoCameraIcon />,
  wallet: <WalletIcon />,
  warning: <WarningIcon />,
  "warning-circle": <WarningCircleIcon />,
  webcam: <WebcamIcon />,
  x: <XIcon />,
  "x-circle": <XCircleIcon />,
  "x-square": <XSquareIcon />,
  "paper-plane-tilt": <PaperPlaneTiltIcon />,
};

export type IconName = keyof typeof iconMap;
